var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main"},[_c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"main-content"},[_c('transition',{attrs:{"name":"el-fade-in"}},[_c('router-view',{key:_vm.key})],1)],1),_c('div',{staticStyle:{"clear":"both"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }